export default __webpack_public_path__ + "static/banner-three-shape6-8b3f1b2a2e3ac334cdf8c87efa94b461.png";